import image from 'shared/assets/images/integrationsSliders/googleSheets/googleSheets1.png'
import { LINK_GOOGLE_SHEETS_GUIDE } from 'shared/constants/links'
import { type IntegrationDetailsData } from 'entities/Integrations/lib/integrationsDescription'

export const google_sheet: IntegrationDetailsData = {
  subheadline:
    'Connect Google Sheets to use your spreadsheet data in real time within your AI agent. Keep information up to date and let your agent respond using the latest data from your sheets.',
  overview:
    'Connect Google Sheets to use your spreadsheet data in real time within your AI agent. Keep information up to date and let your agent respond using the latest data from your sheets.',
  keyBenefits: [
    'Use live data from your Google Sheets in AI conversations',
    'Keep responses accurate with real-time updates',
    'Manage dynamic data like pricing, availability, or lists',
    'No manual updates needed - always uses the latest version',
  ],
  images: [image],
  docs: LINK_GOOGLE_SHEETS_GUIDE,
}
